import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=39dbcd6a&"
import script from "./user-manage.vue?vue&type=script&lang=js&"
export * from "./user-manage.vue?vue&type=script&lang=js&"
import style0 from "./user-manage.vue?vue&type=style&index=0&id=39dbcd6a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports